<template>
  <v-dialog
    :value="isOpen"
    @click:outside="closeMessageDialog()"
    max-width="600"
  >
    <v-card>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        rounded
        height="6"
      ></v-progress-linear>

      <v-card-title class="pa-0 shadow-1">
        <v-img
          :src="require('@/assets/illustrations/bg_modal_card.svg')"
          cover
          position="left bottom"
          class="align-center"
          height="65px"
        >
          <v-card-title class="font-weight-medium primary--text">
            {{ item.title }}
          </v-card-title>
        </v-img>
      </v-card-title>

      <v-card-text>
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <v-card-text class="font-weight-medium">
                <p>{{ item.text }}</p>

                <v-img
                  v-if="item.file"
                  :src="item.file"
                  :lazy-src="item.file"
                  class="grey lighten-2"
                  @click="photoPreview(item.file)"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card-text>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-hover v-slot:default="{ hover }">
          <v-btn
            text
            rounded
            class="mr-1"
            :color="hover ? 'error' : 'grey'"
            @click="closeDialog()"
          >
            Cerrar
          </v-btn>
        </v-hover>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
export default {
  props: {
    isOpen: {
      type: Boolean
    },
    messageId: {
      type: Number
    }
  },
  data() {
    return {
      isLoading: false,
      item: {}
    };
  },
  created() {
    this.getMessage();
  },
  methods: {
    async getMessage() {
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(
          `/message_user/${this.messageId}`
        );
        this.item = data;
      } catch (err) {
        this.$snotify.error("Hubo un error abriendo el mensaje", "Error");
        this.$emit("dialog:close");
      }
      this.isLoading = false;
    },
    closeDialog() {
      this.$emit("dialog:close");
    }
  }
};
</script>

<style></style>
